/*
 * @Author: libo 
 * @Date: 2020-11-13 16:48:46 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-13 12:34:30
 */

<!--用户类型新增界面-->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" :colon="false" slot="detail" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item has-feedback :label="$t('户型编码')">
              <a-input :disabled="!!model.id" v-decorator="['htCode',validatorRules.htCode]" :placeholder="$t('请输入户型编码')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item has-feedback :label="$t('户型名称')">
              <a-input :disabled="!!model.id" v-decorator="['htName',validatorRules.htName]" :placeholder="$t('请输入户型名称')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('日报警量上限')">
              <a-input-number :disabled="disabled" v-decorator="['htDayAlarmTop']" :placeholder="$t('请输入该类用户的日报警量上限')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('日报警下限值')">
              <a-input-number :disabled="disabled" v-decorator="['htDayAlarmLow']" :placeholder="$t('请输入该类用户的日报警下限值')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')">
              <a-textarea :disabled="disabled" v-decorator="['htRemark']" rows="2" :placeholder="$t('请输入备注')"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import {isUndefined} from'@/utils/validate'
  import { mapGetters } from 'vuex'

  export default {
    name: 'MeterHouseholdForm',
    components: {
      JFormContainer,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterHousehold/add",
          edit: "/jeecg-charge/meter/meterHousehold/edit",
          queryById: "/jeecg-charge/meter/meterHousehold/queryById",
          queryMeterHouseholdByUserId: "/jeecg-charge/meter/meterHousehold/list"
        }
      }
    },
    computed: {
      validatorRules () {
        return {
          htCode:{rules: [{ required: true, message: this.$t('请输入户型编码!') },
            {validator: this.validateHtCode}
          ]},
          htName:{rules: [{ required: true, message: this.$t('请选择户型名称') },
            {validator: this.validateHtName}
            ]},
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
    },
    methods: {
      ...mapGetters(["userInfo"]),
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'htCode','htName','htDayAlarmTop','htDayAlarmLow','htRemark','createTime','createBy'))
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'htCode','htName','htDayAlarmTop','htDayAlarmLow','htRemark','createTime','createBy'))
      },
      // 查询类型代码是否重复
      validateHtCode(rule, value, callback) {
        if(isUndefined(value)||value.replace(/\s+/g,'') == '') {
          callback("")
          return
        }
        let org = this.userInfo().orgCode
        let params = {htCode: this.form.getFieldValue('htCode'),sysOrgCode: org}
        getAction(this.url.queryMeterHouseholdByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t('该户型编码已存在!'))
            }
          } else {
            callback()
          }
        })
      },
      // 查询类型代码是否重复
      validateHtName(rule, value, callback) {
        if(isUndefined(value)||value.replace(/\s+/g,'') == '') {
          callback("")
          return
        }
        let org = this.userInfo().orgCode
        let params = {htName: this.form.getFieldValue('htName'),sysOrgCode: org}
        getAction(this.url.queryMeterHouseholdByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t('该户型名称已存在!'))
            }
          } else {
            callback()
          }
        })
      },
    }
  }
</script>